var map = {
	"./CannaProvisions": 81833,
	"./CannaProvisions.tsx": 81833,
	"./Default": 88979,
	"./Default.tsx": 88979,
	"./Nealternatives": 46633,
	"./Nealternatives.tsx": 46633,
	"./Standard": 25405,
	"./Standard.tsx": 25405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5454;